import { AxiosPromise } from 'axios'
import client from './client'
import {
  JahisNsipsStats,
  JahisNsipsStatsParams,
  JahisNsipsMismatches,
  JahisNsipsMismatchesParams,
  HeadquartersPharmacyList,
} from '../types/models/JahisNsipsMatching'

/**
 * JAHIS-NSIPS突合統計を取得
 */
export const getJahisNsipsStats = (
  params: JahisNsipsStatsParams
): AxiosPromise<JahisNsipsStats> => {
  return client.get('/api/jahis-nsips-matching/stats/', { params })
}

/**
 * JAHIS-NSIPS不一致詳細を取得
 */
export const getJahisNsipsMismatches = (
  params: JahisNsipsMismatchesParams
): AxiosPromise<JahisNsipsMismatches> => {
  return client.get('/api/jahis-nsips-matching/mismatches/', { params })
}

/**
 * 本部アカウント向け薬局一覧を取得
 */
export const getHeadquartersPharmacies =
  (): AxiosPromise<HeadquartersPharmacyList> => {
    return client.get('/api/headquarters/pharmacies/')
  }

/**
 * 本部向け 突合一致率 CSV（同期）をダウンロード
 *
 * レスポンスは text/csv; charset=utf-8-sig の blob。
 */
export const exportJahisNsipsMatchSummaryCSV = (params: {
  pharmacy_ids?: string[]
  start_week: string
  end_week: string
}): AxiosPromise<Blob> => {
  return client.post('/api/jahis-nsips-matching/export-summary/', params, {
    responseType: 'blob',
  })
}
